import { nanoid } from "nanoid";

/**
 * Logs client-side errors to CloudWatch via a simple API endpoint
 */
export const logErrorToCloudWatch = async (
    error: Error | string,
    componentStack?: string,
    additionalInfo?: Record<string, any>,
): Promise<void> => {
    try {
        const errorMessage = typeof error === "string" ? error : error.message;
        const errorStack = typeof error === "string" ? undefined : error.stack;

        const payload = {
            componentStack,
            id: nanoid(),
            message: errorMessage,
            stack: errorStack,
            timestamp: new Date().toISOString(),
            ...additionalInfo,
            url: window.location.href,
            userAgent: navigator.userAgent,
        };

        // Send the error to our API endpoint
        await fetch("/api/log-error", {
            body: JSON.stringify(payload),
            headers: {
                "Content-Type": "application/json",
            },
            // and don't let this request fail if the user navigates away
            keepalive: true,
            // Don't wait for the response to avoid blocking the UI
            method: "POST",
        });
    } catch (loggingError) {
        // Silent failure - we don't want errors in our error logger to cause more issues
        console.error("Failed to log error to CloudWatch:", loggingError);
    }
};
